<template>
  <div class="checkout-component-container">
    <div class="checkout-box">
      <div
        v-if="purchased"
        class="inner purchased"
      >
        <div class="title">
          Thank You, {{ $store.getters['session/currentUser'].firstName }}!
        </div>
        <div class="text">
          Your 1 year subscription order is complete and includes extensions for your eligible certifications of A1-A9.
        </div>
        <div class="text">
          A credit card charge receipt will be emailed to you. If you do not receive the email, please check your junk/spam folder.
        </div>
        <div class="title">
          Next Step
        </div>
        <div class="text">
          Start earning credits toward your extensions by answering questions in your certifications.
        </div>
        <router-link :to="{ name: 'home' }">
          Go to My Certifications
        </router-link>
      </div>
      <div
        v-else
        class="inner"
      >
        <div class="title">
          Yearly subscription $48/year (+ tax)
        </div>
        <div class="sub-title">
          By purchasing, you authorize ASE to charge you $48.00 + applicable tax.
        </div>
      </div>
    </div>
    <div class="iframe-container">
      <iframe
        id="purchase-iframe"
        class="printable"
        :src="iframeSrc"
      />
    </div>
  </div>
</template>

<script>
import CertificationsMixin from '@/mixins/certifications';

export default {
  mixins: [CertificationsMixin],
  data() {
    return {
      token: null,
      iframeSrc: null,
      loading: true,
      purchased: false,
    };
  },
  computed: {
    aseHost() {
      return process.env.WEB_ENV === 'production' ? 'https://wbsvccc.ase.com' : 'https://devwbsvccc.ase.com';
    },
  },
  created() {
    if (!this.userCanPurchase) {
      this.$router.push({name: 'home'});
    }
    this.addEvents();
    this.$store.dispatch('purchases/getToken').then(response => {
      this.loading = false;
      this.token = response.data.key;
      this.iframeSrc = `${this.aseHost}/?token=${this.token}`;
    }).catch(error => {
      return Promise.reject(error);
    });

  },
  beforeDestroy() {
    this.removeEvents();
  },
  methods: {
    removeEvents() {
      window.removeEventListener('message', this.transactionComplete);
    },
    addEvents() {
      window.addEventListener('message', this.transactionComplete, false);
    },
    confirmToken(token) {
      return this.$store.dispatch('purchases/confirmPurchase', { token });
    },
    transactionComplete(message) {
      if(message.origin === this.aseHost) {
        this.removeEvents();
        this.confirmToken(this.token).then(response => {
          if(response.data.success) {
            this.purchased = true;
          }
        }).catch(error => {
          return Promise.reject(error);
        });
      }
    },
  },
};
</script>

<style lang='scss' scoped>
  .checkout-component-container {
    background: #eff3f6;
    display: flex;
    flex: 1;
    padding: rem-calc(32) rem-calc(48);

    @include breakpoint(small) {
      flex-direction: column;
      padding: 0;
    }

    .iframe-container {
      box-shadow: 0 0.5px 1px 0 rgba(0, 0, 0, 0.25);
      border-radius: 3px;
      flex: 1;
      -webkit-overflow-scrolling: touch;
    	overflow-y: scroll;
      position: relative;

      @include breakpoint(small) {
        margin-top: rem-calc(16);
        margin-bottom: rem-calc(36);
      }
    }

    #purchase-iframe {
      border: 0;
      height: 100%;
      width: 100%;
    }

    .checkout-box {
      flex: 1;

      @include breakpoint(small) {
        flex: 0;
        margin: 0;
      }

      .inner {
        background: white;
        box-shadow: 0 0.5px 1px 0 rgba(0, 0, 0, 0.25);
        border-radius: 3px;
        color: #354052;
        padding: rem-calc(32);
        margin-right: rem-calc(24);
        max-width: rem-calc(500);

        &.purchased {
          .text {
            margin: rem-calc(16) 0;
          }

          .title {
            font-size: rem-calc(24);
            font-weight: $bold;
          }

          a {
            background-color: #7bd56e;
            border: 1px solid #65BA59;
            border-radius: 4px;
            color: white;
            cursor: pointer;
            display: block;
            font-weight: $semi-bold;
            margin-top: rem-calc(16);
            padding: rem-calc(8);
            text-align: center;
            width: rem-calc(200);
          }
        }

        @include breakpoint(small) {
          margin: 0;
          max-width: 100%;
          padding: rem-calc(16);
        }
      }

      .title {
        font-size: rem-calc(24);
        font-weight: $semi-bold;

        @include breakpoint(small) {
          font-size: rem-calc(22);
        }
      }

      .sub-title {
        margin: rem-calc(16) 0;
      }

      .purchase {
        background-image: linear-gradient(to top, #f2f4f7, #ffffff);
        border: 1px solid rgba(0,0,0,.1);
        border-radius: 4px;
        color: #354052;
        cursor: pointer;
        font-size: rem-calc(20);
        font-weight: $semi-bold;
        display: inline-block;
        margin-top: rem-calc(16);
        padding: rem-calc(8) rem-calc(16);
      }
    }
  }
</style>
